// src/lib/friendsApi.js
// API-calls voor friends, friend-requests en session-invites

function resolveApiBase() {
  if (typeof window !== "undefined" && window.location.hostname === "bondapp.tv") {
    return "https://signal.bondapp.tv";
  }
  if (process.env.REACT_APP_API_BASE) {
    return process.env.REACT_APP_API_BASE;
  }
  if (typeof window !== "undefined" && window.location.hostname === "localhost") {
    return "http://localhost:5000";
  }
  return "http://localhost:5000";
}

const API_BASE = resolveApiBase();

async function request(path, { method = "GET", body, token }) {
  const headers = { "Content-Type": "application/json" };
  if (token) headers.Authorization = `Bearer ${token}`;

   const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
   credentials: "include",
  });


  const data = await res.json().catch(() => ({}));

  if (!res.ok || data.ok === false) {
    const errorCode =
      data?.error ||
      (res.status === 401 ? "UNAUTHENTICATED" : "REQUEST_FAILED");

    const err = new Error(errorCode);
    err.code = errorCode;
    err.status = res.status;
    throw err;
  }

  return data;
}

/* ----------------------------
   USERS ZOEKEN
----------------------------- */
export async function apiSearchUsers(query, token) {
  const q = encodeURIComponent(query || "");
  const data = await request(`/api/users/search?query=${q}`, {
    method: "GET",
    token,
  });
  return data.users; // lijst van {id, username, ...}
}

/* ----------------------------
   VRIENDEN
----------------------------- */
export async function apiGetFriends(token) {
  const data = await request("/api/friends", {
    method: "GET",
    token,
  });
  return data.friends; // array van users
}

/* ----------------------------
   VRIENDSCHAPSVERZOEKEN
----------------------------- */
export async function apiGetFriendRequests(token) {
  const data = await request("/api/friend-requests", {
    method: "GET",
    token,
  });
  return {
    incoming: data.incoming,
    outgoing: data.outgoing,
  };
}

export async function apiSendFriendRequest(username, token) {
  const data = await request("/api/friend-requests", {
    method: "POST",
    token,
    body: { username },
  });
  return data.request;
}

export async function apiRespondFriendRequest(id, action, token) {
  const data = await request(`/api/friend-requests/${id}`, {
    method: "POST",
    token,
    body: { action },
  });
  return data.request;
}

/* ----------------------------
   SESSIE-UITNODIGINGEN
----------------------------- */
export async function apiGetSessionInvites(token) {
  const data = await request("/api/session-invites", {
    method: "GET",
    token,
  });
  return {
    incoming: data.incoming,
    outgoing: data.outgoing,
  };
}

export async function apiSendSessionInvites(friendIds, sessionCode, token) {
  const data = await request("/api/session-invites", {
    method: "POST",
    token,
    body: { friendIds, sessionCode },
  });
  return data.invites; // lijst van invites
}
